import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useParams } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { ReportsWorkspace } from './reports/ReportsWorkspace';
import CalculationMethodology from './reports/CalculationMethodology';
import { BatchBuilder } from '@/components/reports/BatchBuilder';
import { BatchRunProgress } from '@/components/reports/BatchRunProgress';
import { SavedBatchesList } from '@/components/reports/SavedBatchesList';
import type { BatchDefinitionResponse } from '@/api/batchReportsApi';

const Reports: React.FC = () => {
  return (
    <Routes>
      <Route path="methodology" element={
        <MainLayout title="Calculation Methodology">
          <CalculationMethodology />
        </MainLayout>
      } />
      <Route path="batch" element={
        <MainLayout title="Reports">
          <BatchBuilderPage />
        </MainLayout>
      } />
      <Route path="batch/:runId" element={
        <MainLayout title="Reports">
          <BatchRunProgressPage />
        </MainLayout>
      } />
      <Route path="*" element={
        <MainLayout title="Reports">
          <ReportsWorkspace />
        </MainLayout>
      } />
    </Routes>
  );
};

function BatchBuilderPage() {
  const location = useLocation();
  const [selectedDefinition, setSelectedDefinition] = useState<BatchDefinitionResponse | null>(() => {
    const state = location.state as { batchDefinition?: BatchDefinitionResponse } | null;
    return state?.batchDefinition ?? null;
  });

  // Sync from navigation state when user navigates here with state (e.g. from a link)
  useEffect(() => {
    const state = location.state as { batchDefinition?: BatchDefinitionResponse } | null;
    if (state?.batchDefinition != null) {
      setSelectedDefinition(state.batchDefinition);
    }
  }, [location.state]);

  return (
    <div className="p-4 lg:p-6">
      <SavedBatchesList
        className="mb-8"
        onSelectBatch={setSelectedDefinition}
      />
      <BatchBuilder
        key={selectedDefinition?.id ?? 'new'}
        initialBatchDefinition={selectedDefinition}
        className="mt-8"
      />
    </div>
  );
}

function BatchRunProgressPage() {
  const { runId = '' } = useParams<{ runId: string }>();
  return (
    <div className="p-4 lg:p-6">
      <BatchRunProgress batchRunId={runId} />
    </div>
  );
}

export default Reports;